import script from "./InventoryTemplatePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InventoryTemplatePage.vue?vue&type=script&setup=true&lang=ts"

import "./InventoryTemplatePage.vue?vue&type=style&index=0&id=2a24d081&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a24d081"]])

export default __exports__